module.exports = __webpack_public_path__ + "static/media/trash.a4cb6196.svg";